module.exports = __webpack_public_path__ + "img/map.9a4bec5 1.a0df67d.svg";